/**
 * Очередь пушей на экранах входа и регистрации.
 *
 * Преимущества продукта и признаки живой активности лежат одним списком,
 * а не двумя: на экране это один поток, и чередование «тезис — активность»
 * задаётся здесь порядком, а не сортировкой в компоненте. Три рекламных
 * блока подряд читались бы как баннер, который взгляд пропускает.
 */
export const AUTH_PUSHES = [
  {
    id: 'feed',
    kind: 'feature',
    title: 'Лента без чужого мнения о том, что вам интересно',
    description: 'Хронология и темы, которые выбрали вы, а не алгоритм за вас.',
  },
  {
    id: 'mira',
    kind: 'activity',
    title: 'Мира зашла в «созвон» — 3 участника',
  },
  {
    id: 'voice',
    kind: 'feature',
    title: 'Голос, который включается за секунду',
    description: 'Комнаты на SFU: восемь человек в звонке — и вентилятор молчит.',
  },
  {
    id: 'kostya',
    kind: 'activity',
    title: 'Костя опубликовал заметку о токенах',
  },
  {
    id: 'spaces',
    kind: 'feature',
    title: 'Спейсы для команд и своих',
    description: 'Текстовые каналы, треды и созвоны рядом с лентой, а не вместо неё.',
  },
  {
    id: 'product',
    kind: 'activity',
    title: 'В «Продукте» 12 новых сообщений',
  },
] as const

export type AuthPush = (typeof AUTH_PUSHES)[number]

/**
 * Пауза между появлениями. Заметно меньше времени жизни пуша
 * (`--push-life` в стилях), поэтому на экране их два-три сразу:
 * поток должен читаться как поток, а не как одна карточка по кругу.
 */
export const PUSH_INTERVAL_MS = 3600

/**
 * Задержка перед первым пушем. Короче интервала: ждать четыре секунды на
 * пустом экране незачем. Но и не ноль — карточка формы должна доиграть свой
 * выезд, иначе два движения стартуют одновременно и спорят за внимание.
 */
export const PUSH_FIRST_DELAY_MS = 900

/**
 * Ширина, с которой поток вообще существует.
 *
 * Значение дублирует `ds.up('lg')` в стилях намеренно: CSS отвечает за то,
 * что видно, а компонент — за то, что работает. Без второй проверки таймер
 * тикал бы и на телефоне, где блок скрыт, а по повороту экрана вывалил бы
 * накопленную стопку разом.
 */
export const PUSH_MEDIA_QUERY = '(min-width: 1024px)'

/**
 * Потолок одновременно висящих пушей.
 *
 * Уходят они сами по концу анимации, но в фоновой вкладке анимации стоят,
 * а таймер — нет. Без потолка возврат на вкладку показал бы стопку из
 * всего, что накопилось.
 */
export const MAX_VISIBLE_PUSHES = 3
